import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrentUserModule } from '®shared/current-user';

import { LtiMissingContentComponent } from './lti-missing-content.component';

@NgModule({
  imports: [CommonModule, CurrentUserModule.forRoot()],
  declarations: [LtiMissingContentComponent],
  exports: [LtiMissingContentComponent],
})
export class LtiMissingContentModule {}
